import { React } from 'Imports';
import { isEncompass } from '$Utilities/integrationPlatform';

const styles = require('./ActionSection.scss') as {
    containerGeotab: string;
    containerEncompass: string;
    titleGeotab: string;
    titleEncompass: string;
    descriptionGeotab: string;
    descriptionEncompass: string;
};

interface ActionSectionProps {
    title: string;
    description: string;
    children?: React.ReactNode;
}
const ActionSection = (props: ActionSectionProps) => {
    return (
        <div className={isEncompass ? styles.containerEncompass : styles.containerGeotab}>
            <div className={isEncompass ? styles.titleEncompass : styles.titleGeotab}>{props.title}</div>
            <div className={isEncompass ? styles.descriptionEncompass : styles.descriptionGeotab}>{props.description}</div>
            <div>{props.children}</div>
        </div>
    );
};

export default ActionSection;
